<div class="timeline-container">
    <button *ngIf="presentExpansionView" mat-icon-button (click)="expandView()"><mat-icon>open_in_full</mat-icon></button>
    <div *ngFor="let item of presentedValues; index as itemIdx" class="timeline-event">
        <div class="timeline-point-track-container">
            <div class="timeline-point" [ngStyle]="{'border-color': getItemColortByType(item.type)}"></div>
            <div *ngIf="itemIdx+1 < presentedValues.length" class="timeline-track"></div>
        </div>
        <div class="timeline-content-container">
            <div class="timeline-content-container">
                <div class="timeline-content-text">
                    {{item.content}}
                </div>
                <!-- <div *ngIf="itemType == moovEventTypeEnumInstanace.StepDone && additionalText != ''" class="timeline-stepDoneComment"> -->
                <div *ngIf="item.type == 6 && item.additionalText != ''"class="timeline-stepDoneComment">
                    {{item.additionalText}}
                </div>
                <div class="timeline-content-footer">
                    <div class="timeline-content-date">
                        {{item.timeStamp}}
                    </div>
                    <!-- <div *ngIf="item.type === moovEventTypeEnumInstanace.Feedback" class="timelline-score"> -->
                    <div *ngIf="item.type === 3" class="timelline-score">
                        <app-claro-star-rating [rating]="item.score" [disabled]="true"></app-claro-star-rating>
                    </div>
                </div>
            </div>    
        </div>
    </div>
</div>